import { frontendCurrency } from "utils/formatCurrency"

export const NeutralNumber = (number: number) => {
  return (
    <span className={`${number === 0 ? "tw-text-primary-50" : ""}`}>
      {frontendCurrency(number)}
    </span>
  )
}
